import { useCallback } from 'react';

import { useEnsureFavorite } from '@spotify/plugin-confidence-collections-react';
import {
  type TaskFragment,
  type TaskInputResponseInput,
  useProvideTaskInput,
} from '@spotify/plugin-confidence-issues-react';

export type UseProvideIssueTaskInputResult = {
  provideIssueTaskInput: (
    taskName: string,
    inputResponse: TaskInputResponseInput,
  ) => Promise<TaskFragment>;
  isMutating: boolean;
};

export const useProvideIssueTaskInput = (
  issueName: string,
): UseProvideIssueTaskInputResult => {
  const { provideTaskInput, isMutating } = useProvideTaskInput({
    onError: 'post-alert',
  });
  const { ensureFavorite } = useEnsureFavorite();

  const provideIssueTaskInput = useCallback(
    async (
      taskName: string,
      inputResponse: TaskInputResponseInput,
    ): Promise<TaskFragment> => {
      const task = await provideTaskInput(taskName, inputResponse);
      void ensureFavorite(issueName);
      return task;
    },
    [provideTaskInput, ensureFavorite, issueName],
  );

  return { provideIssueTaskInput, isMutating };
};
